import { css } from 'styled-components';

export const POPPINS_REGULAR = 'Poppins Regular';
export const POPPINS_MEDIUM = 'Poppins Medium';
export const POPPINS_SEMIBOLD = 'Poppins SemiBold';
export const POPPINS_BOLD = 'Poppins Bold';

const NOTO_SANS_JP = 'Noto Sans JP';

export const THEME = {
  color: {
    background: '#FFFFFF',
    onPrimary: '#FFFFFF',
    onSurface: '#363636',
    onError: '#FFFFFF',
    quartzColor: '#4E4744',
    surface: '#F7F7F7',
    surfaceDark: '#F8F7F7',
    surfaceLight: '#E7E7E7',
    surfaceMediumEmphasis: 'rgba(247, 247, 247, 0.5);',
    onBackgroundHighEmphasis: '#363636',
    onBackgroundMediumEmphasis: '#A1A1A1',
    onBackgroundLowEmphasis: '#D4D4D4',
    primaryBase: '#FF4C00',
    primaryHover: '#FFA580',
    primaryPressed: '#DB4100',
    primarySubtle: '#FFF2EB',
    linkHighEmphasis: '#0075FF',
    linkLowEmphasis: '#E5F1FF',
    errorHighEmphasis: '#DE1C22',
    errorLowEmphasis: '#FCE9E9',
    successHighEmphasis: '#59C825',
    successLowEmphasis: '#EFFBE9',
    rateHighEmphasis: '#FFCC15',
    rateLowEmphasis: '#FFF9E5',
    pendingHighEmphasis: '#FF9900',
    pendingLowEmphasis: '#FFF5E5',
    boxShadow: {
      primaryHover: '0px 8px 8px rgba(161, 161, 161, 0.25)',
      primaryFocus: '0px 4px 4px rgba(161, 161, 161, 0.25)',
      defaultBoxshadow: '0px 4px 10px rgba(33,33,33,0.1)',
      socialMedia: '2px 2px #0E9641',
      cardRaiseMiddleShadow: '0px 4px 15px rgba(33, 33, 33, 0.15)',
      listingCard: `0px 6px 6px rgba(161, 161, 161, 0.25)`,
    },
    border: '#EDEDED',
    borderShadow: 'rgba(33, 33, 33, 0.15)',
    socialMediaBackground: '#26D367',
    lightOrange: '#FF5722',
    darkBackground: '#000000',
    carDetailTopNav: 'rgba(255, 255, 255, 0.8)',
    sliderCTABackground: 'rgba(255, 255, 255, 0.6)',
    sliderCTABorder: 'rgba(255, 255, 255, 0.5)',
    sliderCTAMobileBackround: 'rgba(0, 0, 0, 0.6)',
    sliderCTAMobileBorder: 'rgba(0, 0, 0, 0.5)',
    lightMode: 'rgba(255, 242, 235, 1)',
    webkitScrollBar: '#e3e3e8',
    webkitScrollBarThumb: '#8f90a3',
    pureRed: '#ff0000',
    fbColor: '#415994',
    darkShapeBlue: '#021039',
    gray: '#878787',
    darkGray: '#67696f',
    disabled: '#e7e7e7',
    lightDark: '#212121',
    lightGray: '#6e6e6e',
    lightGreen: '#00b900',
    lightBlue: '#03B3AE',
    detailsBackground: 'rgba(33, 33, 33, 0.02)',
    pointSeparator: '#3B3B3B',
    lightPink: 'rgba(255, 165, 128, 1)',
    lightGrey: '#767676',
    tealHighEmphasis: '#008C95',
    gunPowder: '#4E4E4F',
  },
  typo: {
    family: {
      regular: POPPINS_REGULAR,
      medium: POPPINS_MEDIUM,
      semiBold: POPPINS_SEMIBOLD,
      bold: POPPINS_BOLD,
    },
    familyGoogle: {
      regular: css`
        font-family: var(--font-system-poppins);
        font-weight: 400;
      `,
      medium: css`
        font-family: var(--font-system-poppins);
        font-weight: 500 !important;
      `,
      semiBold: css`
        font-family: var(--font-system-poppins);
        font-weight: 600 !important;
      `,
      bold: css`
        font-family: var(--font-system-poppins);
        font-weight: 700 !important;
      `,
      light: css`
        font-family: var(--font-system-poppins);
        font-weight: 300;
      `,
    },
    style: {
      xlHeader: css`
        font-weight: 700;
        font-size: 38px;
        line-height: 46px;
      `,
      lHeader: css`
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
      `,
      mHeader: css`
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
      `,
      sHeader: css`
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      `,
      header: css`
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      `,
      body: css`
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      `,
      mainButtonOrLink: css`
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
      `,
      smallButtonOrLink: css`
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
      `,
      captionBold: css`
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
      `,
      captionRegular: css`
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      `,
      label: css`
        font-weight: 500;
        font-size: 10px;
        line-height: 16px;
      `,
    },
  },
  metrics: {
    breakpoints: {
      xs: '375px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1280px',
      xxl: '1920px',
    },
    mediaQueries: {
      xs: `(max-width: 375px)`,
      sm: `(min-width: 376px) and (max-width: 576px)`,
      md: `(min-width: 577px) and (max-width: 768px)`,
      lg: `(min-width: 769px) and (max-width: 992px)`,
      xl: `(min-width: 993px) and (max-width: 1280px)`,
      xxl: `(min-width: 1281px)`,
    },
    containers: {
      padding: {
        xs: '16px',
        sm: '16px',
        md: '16px',
        lg: '48px',
        xl: '0',
      },
    },
  },
};

export const THEME_SG_SC = {
  ...THEME,
  typo: {
    ...THEME.typo,
    familyGoogle: {
      regular: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 400;
      `,
      medium: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 500 !important;
      `,
      light: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 300;
      `,
      semiBold: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 600 !important;
      `,
      bold: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 700 !important;
      `,
    },
  },
};

export const THEME_HK_SC = {
  color: {
    background: '#FFFFFF',
    onPrimary: '#FFFFFF',
    onSurface: '#363636',
    onError: '#FFFFFF',
    quartzColor: '#4E4744',
    surface: '#F7F7F7',
    surfaceDark: '#F8F7F7',
    surfaceLight: '#E7E7E7',
    surfaceMediumEmphasis: 'rgba(247, 247, 247, 0.5);',
    onBackgroundHighEmphasis: '#363636',
    onBackgroundMediumEmphasis: '#A1A1A1',
    onBackgroundLowEmphasis: '#D4D4D4',
    primaryBase: '#FF4C00',
    primaryHover: '#FFA580',
    primaryPressed: '#DB4100',
    primarySubtle: '#FFF2EB',
    linkHighEmphasis: '#0075FF',
    linkLowEmphasis: '#E5F1FF',
    errorHighEmphasis: '#DE1C22',
    errorLowEmphasis: '#FCE9E9',
    successHighEmphasis: '#59C825',
    successLowEmphasis: '#EFFBE9',
    rateHighEmphasis: '#FFCC15',
    rateLowEmphasis: '#FFF9E5',
    pendingHighEmphasis: '#FF9900',
    pendingLowEmphasis: '#FFF5E5',
    boxShadow: {
      primaryHover: '0px 8px 8px rgba(161, 161, 161, 0.25)',
      primaryFocus: '0px 4px 4px rgba(161, 161, 161, 0.25)',
      defaultBoxshadow: '0px 4px 10px rgba(33,33,33,0.1)',
      socialMedia: '2px 2px #0E9641',
      cardRaiseMiddleShadow: '0px 4px 15px rgba(33, 33, 33, 0.15)',
      listingCard: `0px 6px 6px rgba(161, 161, 161, 0.25)`,
    },
    border: '#EDEDED',
    borderShadow: 'rgba(33, 33, 33, 0.15)',
    socialMediaBackground: '#26D367',
    lightOrange: '#FF5722',
    darkBackground: '#000000',
    carDetailTopNav: 'rgba(255, 255, 255, 0.8)',
    sliderCTABackground: 'rgba(255, 255, 255, 0.6)',
    sliderCTABorder: 'rgba(255, 255, 255, 0.5)',
    sliderCTAMobileBackround: 'rgba(0, 0, 0, 0.6)',
    sliderCTAMobileBorder: 'rgba(0, 0, 0, 0.5)',
    lightMode: 'rgba(255, 242, 235, 1)',
    webkitScrollBar: '#e3e3e8',
    webkitScrollBarThumb: '#8f90a3',
    pureRed: '#ff0000',
    fbColor: '#415994',
    darkShapeBlue: '#021039',
    gray: '#878787',
    darkGray: '#67696f',
    disabled: '#e7e7e7',
    lightDark: '#212121',
    lightGray: '#6e6e6e',
    lightGreen: '#00b900',
    lightBlue: '#03B3AE',
    detailsBackground: 'rgba(33, 33, 33, 0.02)',
    pointSeparator: '#3B3B3B',
    lightPink: 'rgba(255, 165, 128, 1)',
    lightGrey: '#767676',
    gunPowder: '#4E4E4F',
    tealHighEmphasis: '#008C95',
  },
  typo: {
    familyGoogle: {
      regular: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 400;
      `,
      medium: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 500 !important;
      `,
      light: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 300;
      `,
      semiBold: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 600 !important;
      `,
      bold: css`
        font-family: var(--font-system-noto-sc);
        font-weight: 700 !important;
      `,
    },
    style: {
      xlHeader: css`
        font-weight: 700;
        font-size: 38px;
        line-height: 46px;
      `,
      lHeader: css`
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
      `,
      mHeader: css`
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
      `,
      sHeader: css`
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      `,
      header: css`
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      `,
      body: css`
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      `,
      mainButtonOrLink: css`
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
      `,
      smallButtonOrLink: css`
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
      `,
      captionBold: css`
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
      `,
      captionRegular: css`
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      `,
      label: css`
        font-weight: 500;
        font-size: 10px;
        line-height: 16px;
      `,
    },
  },
  metrics: {
    breakpoints: {
      xs: '375px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1280px',
      xxl: '1920px',
    },
    mediaQueries: {
      xs: `(max-width: 375px)`,
      sm: `(min-width: 376px) and (max-width: 576px)`,
      md: `(min-width: 577px) and (max-width: 768px)`,
      lg: `(min-width: 769px) and (max-width: 992px)`,
      xl: `(min-width: 993px) and (max-width: 1280px)`,
      xxl: `(min-width: 1281px)`,
    },
    containers: {
      padding: {
        xs: '16px',
        sm: '16px',
        md: '16px',
        lg: '48px',
        xl: '0',
      },
    },
  },
};

export const THEME_HK_TC = {
  ...THEME_HK_SC,
  typo: {
    familyGoogle: {
      regular: css`
        font-family: var(--font-system-noto-tc);
        font-weight: 400;
      `,
      medium: css`
        font-family: var(--font-system-noto-tc);
        font-weight: 500 !important;
      `,
      light: css`
        font-family: var(--font-system-noto-tc);
        font-weight: 300;
      `,
      semiBold: css`
        font-family: var(--font-system-noto-tc);
        font-weight: 600 !important;
      `,
      bold: css`
        font-family: var(--font-system-noto-tc);
        font-weight: 700 !important;
      `,
    },
    style: {
      xlHeader: css`
        font-weight: 700;
        font-size: 38px;
        line-height: 46px;
      `,
      lHeader: css`
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
      `,
      mHeader: css`
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
      `,
      sHeader: css`
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      `,
      header: css`
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      `,
      body: css`
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      `,
      mainButtonOrLink: css`
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
      `,
      smallButtonOrLink: css`
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
      `,
      captionBold: css`
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
      `,
      captionRegular: css`
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      `,
      label: css`
        font-weight: 500;
        font-size: 10px;
        line-height: 16px;
      `,
    },
  },
};

export const THEME_JP = {
  color: {
    background: '#FFFFFF',
    onPrimary: '#FFFFFF',
    onSurface: '#363636',
    onError: '#FFFFFF',
    quartzColor: '#4E4744',
    surface: '#F7F7F7',
    surfaceDark: '#F8F7F7',
    surfaceLight: '#E7E7E7',
    surfaceMediumEmphasis: 'rgba(247, 247, 247, 0.5);',
    onBackgroundHighEmphasis: '#363636',
    onBackgroundMediumEmphasis: '#A1A1A1',
    onBackgroundLowEmphasis: '#D4D4D4',
    primaryBase: '#FF4C00',
    primaryHover: '#FFA580',
    primaryPressed: '#DB4100',
    primarySubtle: '#FFF2EB',
    linkHighEmphasis: '#0075FF',
    linkLowEmphasis: '#E5F1FF',
    errorHighEmphasis: '#DE1C22',
    errorLowEmphasis: '#FCE9E9',
    successHighEmphasis: '#59C825',
    successLowEmphasis: '#EFFBE9',
    rateHighEmphasis: '#FFCC15',
    rateLowEmphasis: '#FFF9E5',
    pendingHighEmphasis: '#FF9900',
    pendingLowEmphasis: '#FFF5E5',
    boxShadow: {
      primaryHover: '0px 8px 8px rgba(161, 161, 161, 0.25)',
      primaryFocus: '0px 4px 4px rgba(161, 161, 161, 0.25)',
      defaultBoxshadow: '0px 4px 10px rgba(33,33,33,0.1)',
      socialMedia: '2px 2px #0E9641',
      cardRaiseMiddleShadow: '0px 4px 15px rgba(33, 33, 33, 0.15)',
      listingCard: `0px 6px 6px rgba(161, 161, 161, 0.25)`,
    },
    border: '#EDEDED',
    borderShadow: 'rgba(33, 33, 33, 0.15)',
    socialMediaBackground: '#26D367',
    lightOrange: '#FF5722',
    darkBackground: '#000000',
    carDetailTopNav: 'rgba(255, 255, 255, 0.8)',
    sliderCTABackground: 'rgba(255, 255, 255, 0.6)',
    sliderCTABorder: 'rgba(255, 255, 255, 0.5)',
    sliderCTAMobileBackround: 'rgba(0, 0, 0, 0.6)',
    sliderCTAMobileBorder: 'rgba(0, 0, 0, 0.5)',
    lightMode: 'rgba(255, 242, 235, 1)',
    webkitScrollBar: '#e3e3e8',
    webkitScrollBarThumb: '#8f90a3',
    pureRed: '#ff0000',
    fbColor: '#415994',
    darkShapeBlue: '#021039',
    gray: '#878787',
    darkGray: '#67696f',
    disabled: '#e7e7e7',
    lightDark: '#212121',
    lightGray: '#6e6e6e',
    lightGreen: '#00b900',
    lightBlue: '#03B3AE',
    detailsBackground: 'rgba(33, 33, 33, 0.02)',
    pointSeparator: '#3B3B3B',
    lightPink: 'rgba(255, 165, 128, 1)',
    lightGrey: '#767676',
    tealHighEmphasis: '#008C95',
    gunPowder: '#4E4E4F',
  },
  typo: {
    family: {
      regular: NOTO_SANS_JP,
      medium: NOTO_SANS_JP,
      semiBold: NOTO_SANS_JP,
      bold: NOTO_SANS_JP,
    },
    familyGoogle: {
      regular: css`
        font-family: var(--font-system-noto-jp);
        font-weight: 400;
      `,
      medium: css`
        font-family: var(--font-system-noto-jp);
        font-weight: 500 !important;
      `,
      light: css`
        font-family: var(--font-system-noto-jp);
        font-weight: 300;
      `,
      semiBold: css`
        font-family: var(--font-system-noto-jp);
        font-weight: 600 !important;
      `,
      bold: css`
        font-family: var(--font-system-noto-jp);
        font-weight: 700 !important;
      `,
    },
    style: {
      xlHeader: css`
        font-weight: 700;
        font-size: 38px;
        line-height: 46px;
      `,
      lHeader: css`
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
      `,
      mHeader: css`
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
      `,
      sHeader: css`
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      `,
      header: css`
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
      `,
      body: css`
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      `,
      mainButtonOrLink: css`
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
      `,
      smallButtonOrLink: css`
        font-weight: 600;
        font-size: 12px;
        line-height: 20px;
      `,
      captionBold: css`
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
      `,
      captionRegular: css`
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      `,
      label: css`
        font-weight: 500;
        font-size: 10px;
        line-height: 16px;
      `,
    },
  },
  metrics: {
    breakpoints: {
      xs: '375px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1280px',
      xxl: '1920px',
    },
    mediaQueries: {
      xs: `(max-width: 375px)`,
      sm: `(min-width: 376px) and (max-width: 576px)`,
      md: `(min-width: 577px) and (max-width: 768px)`,
      lg: `(min-width: 769px) and (max-width: 992px)`,
      xl: `(min-width: 993px) and (max-width: 1280px)`,
      xxl: `(min-width: 1281px)`,
    },
    containers: {
      padding: {
        xs: '16px',
        sm: '16px',
        md: '16px',
        lg: '48px',
        xl: '0',
      },
    },
  },
};

export const FONT_VARIABLES = css`
  :root {
    /* Base Poppins for numbers and Latin fallback */
    --font-poppins: 'Poppins', sans-serif;
    --font-poppins-everything: 'PoppinsEverything', sans-serif;
    --font-noto-sans-jp: 'Noto Sans JP', sans-serif;
    --font-noto-sans-sc: 'Noto Sans SC', sans-serif;
    --font-noto-sans-tc: 'Noto Sans TC', sans-serif;

    /* Mixed fonts: Numbers use Poppins, Letters use regional fonts */
    --font-mixed-poppins: 'Poppins', sans-serif;
    --font-mixed-noto-jp: 'Poppins', 'Noto Sans JP', sans-serif;
    --font-mixed-noto-sc: 'Poppins', 'Noto Sans SC', sans-serif;
    --font-mixed-noto-tc: 'Poppins', 'Noto Sans TC', sans-serif;
  }

  /* Poppins definitions for all unicode ranges */
  @font-face {
    font-family: 'PoppinsEverything';
    src: url('/fonts/poppins/poppins-400.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: 'PoppinsEverything';
    src: url('/fonts/poppins/poppins-500.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
  }
  @font-face {
    font-family: 'PoppinsEverything';
    src: url('/fonts/poppins/poppins-600.woff2') format('woff2');
    font-weight: 600;
    font-display: swap;
  }
  @font-face {
    font-family: 'PoppinsEverything';
    src: url('/fonts/poppins/poppins-700.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
  }

  /* Font-face definitions with unicode ranges */
  @font-face {
    font-family: 'PoppinsNumbers';
    src: url('/fonts/poppins/poppins-400.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;
    unicode-range: U+0030-0039; /* Numbers 0-9 */
  }

  @font-face {
    font-family: 'PoppinsNumbers';
    src: url('/fonts/poppins/poppins-500.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
    unicode-range: U+0030-0039; /* Numbers 0-9 */
  }

  @font-face {
    font-family: 'PoppinsNumbers';
    src: url('/fonts/poppins/poppins-600.woff2') format('woff2');
    font-weight: 600;
    font-display: swap;
    unicode-range: U+0030-0039; /* Numbers 0-9 */
  }

  @font-face {
    font-family: 'PoppinsNumbers';
    src: url('/fonts/poppins/poppins-700.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
    unicode-range: U+0030-0039; /* Numbers 0-9 */
  }

  /* Poppins for letters (Latin subset) */
  @font-face {
    font-family: 'PoppinsLetters';
    src: url('/fonts/poppins/poppins-400.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;
    unicode-range: U+0041-005A, U+0061-007A, U+00C0-00D6, U+00D8-00F6, U+00F8-00FF; /* Latin letters */
  }

  @font-face {
    font-family: 'PoppinsLetters';
    src: url('/fonts/poppins/poppins-500.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
    unicode-range: U+0041-005A, U+0061-007A, U+00C0-00D6, U+00D8-00F6, U+00F8-00FF; /* Latin letters */
  }

  @font-face {
    font-family: 'PoppinsLetters';
    src: url('/fonts/poppins/poppins-600.woff2') format('woff2');
    font-weight: 600;
    font-display: swap;
    unicode-range: U+0041-005A, U+0061-007A, U+00C0-00D6, U+00D8-00F6, U+00F8-00FF; /* Latin letters */
  }

  @font-face {
    font-family: 'PoppinsLetters';
    src: url('/fonts/poppins/poppins-700.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
    unicode-range: U+0041-005A, U+0061-007A, U+00C0-00D6, U+00D8-00F6, U+00F8-00FF; /* Latin letters */
  }

  /* Noto Sans TC Text*/
  // Ref: https://www.unicode.org/charts/PDF/U4E00.pdf
  @font-face {
    font-family: 'NotoSansTC-Text';
    src: url('/fonts/noto-sans-tc/noto-sans-tc-400.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;
    unicode-range: U+4E00-9FFF; /* CJK Unified Ideographs - https://www.unicode.org/charts/PDF/U4E00.pdf */
  }

  @font-face {
    font-family: 'NotoSansTC-Text';
    src: url('/fonts/noto-sans-tc/noto-sans-tc-500.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
    unicode-range: U+4E00-9FFF; /* CJK Unified Ideographs*/
  }

  @font-face {
    font-family: 'NotoSansTC-Text';
    src: url('/fonts/noto-sans-tc/noto-sans-tc-700.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
    unicode-range: U+4E00-9FFF; /* CJK Unified Ideographs */
  }

  /* Noto Sans SC for punctuation (especially ，and  。 ) */
  // Ref: https://www.unicode.org/charts/PDF/U3000.pdf
  // https://www.unicode.org/charts/PDF/UFF00.pdf
  @font-face {
    font-family: 'NotoSansSC-Punctuation';
    src: url('/fonts/noto-sans-sc/noto-sans-sc-400.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;

    unicode-range: U+3000-303F, U+FF00-FFEF; /* CJK Punctuation and Symbols */
  }

  @font-face {
    font-family: 'NotoSansSC-Punctuation';
    src: url('/fonts/noto-sans-sc/noto-sans-sc-500.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
    unicode-range: U+3000-303F, U+FF00-FFEF; /* CJK Punctuation and Symbols */
  }

  @font-face {
    font-family: 'NotoSansSC-Punctuation';
    src: url('/fonts/noto-sans-sc/noto-sans-sc-700.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
    unicode-range: U+3000-303F, U+FF00-FFEF; /* CJK Punctuation and Symbols */
  }

  /* Regional font families with mixed number/letter support */
  :root {
    --font-system-poppins: 'PoppinsNumbers', 'PoppinsLetters', 'Poppins', sans-serif;
    --font-system-noto-jp: 'PoppinsNumbers', 'PoppinsLetters', 'Noto Sans JP', sans-serif;
    --font-system-noto-sc: 'PoppinsNumbers', 'PoppinsLetters', 'Noto Sans SC', sans-serif;
    --font-system-noto-tc: 'NotoSansTC-Text', 'NotoSansSC-Punctuation', 'PoppinsNumbers', 'PoppinsLetters', sans-serif;
  }
`;

export default THEME;
